// import * as React from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Card,
//   TextField,
//   Grid,
//   IconButton,
//   Stack,
//   Tooltip,
//   Typography,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
// } from "@mui/material";
// import {
//   CheckCircle as AcceptIcon,
//   Cancel as RejectIcon,
//   Pending as PendingIcon,
// } from "@mui/icons-material";
// import { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import MainCard from "ui-component/cards/MainCard";
// import { gridSpacing } from "store/constant";
// import { useDebounce } from "hooks/useDebounced";

// const PASS_STATUS = {
//   PENDING: "pending",
//   ACCEPTED: "accept",
//   REJECTED: "reject",
// };

// export default function EntryApprovalStaff() {
//   const [page, setPage] = useState(0);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [updatingStatus, setUpdatingStatus] = useState({});

//   const debouncedSearch = useDebounce(search, 1000);

//   // ✅ Fetch staff's submitted gate passes
//   const fetchStaffGatePasses = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: page + 1,
//         limit: rowsPerPage,
//         search,
//         status: statusFilter,
//       });

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}staff/all-after-work-entry-exit-approval?${queryParams}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.code === 200) {
//         setRows(result.data.entryApprovals || []);
//         setTotal(result.data.pagination?.total || 0);
//       } else {
//         toast.error(result.message || "Failed to fetch approvals");
//         setRows([]);
//         setTotal(0);
//       }
//     } catch (error) {
//       console.error("Error fetching approvals:", error);
//       toast.error("Something went wrong while fetching approvals");
//       setRows([]);
//       setTotal(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchStaffGatePasses();
//   }, [page, rowsPerPage, debouncedSearch, statusFilter]);

//   // ✅ Pagination
//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const handleStatusFilter = (event) => {
//     setStatusFilter(event.target.value);
//     setPage(0);
//   };

//   // ✅ Update staff status
//   const updateStaffStatus = async (id, newStatus, name) => {
//     if (updatingStatus[id]) return;

//     const actionText = newStatus === PASS_STATUS.ACCEPTED ? "Accept" : "Reject";

//     swal({
//       title: `${actionText} ${name}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this approval?`,
//       icon: newStatus === PASS_STATUS.ACCEPTED ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: newStatus === PASS_STATUS.REJECTED,
//     }).then(async (willProceed) => {
//       if (!willProceed) return;

//       try {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}update-staff-entryapproval-status/${id}`,
//           {
//             method: "PUT",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );

//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success(`Approval ${actionText}ed successfully`);
//           setRows((prev) =>
//             prev.map((item) => (item._id === id ? { ...item, staff_status: newStatus } : item))
//           );
//         } else {
//           toast.error(result.message || `Failed to ${actionText.toLowerCase()} approval`);
//         }
//       } catch (error) {
//         console.error("Error updating staff status:", error);
//         toast.error("Something went wrong while updating approval");
//       } finally {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
//       }
//     });
//   };

//   // ✅ Status chip UI
//   const getStatusChip = (status) => {
//     const statusConfig = {
//       pending: { color: "warning", icon: <PendingIcon />, label: "Pending" },
//       accept: { color: "success", icon: <AcceptIcon />, label: "Accepted" },
//       reject: { color: "error", icon: <RejectIcon />, label: "Rejected" },
//     };
//     const config = statusConfig[status] || statusConfig.pending;

//     return (
//       <Chip
//         icon={config.icon}
//         label={config.label}
//         color={config.color}
//         size="small"
//         variant="outlined"
//       />
//     );
//   };

//   const formatDate = (dateString) =>
//     new Date(dateString).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });

//   return (
//     <>
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Search approvals..."
//             type="search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Name, employee ID..."
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth>
//             <InputLabel>Status Filter</InputLabel>
//             <Select value={statusFilter} onChange={handleStatusFilter} label="Status Filter">
//               <MenuItem value="all">All Status</MenuItem>
//               <MenuItem value="pending">Pending</MenuItem>
//               <MenuItem value="accept">Accepted</MenuItem>
//               <MenuItem value="reject">Rejected</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <MainCard
//         title={
//           <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
//             <Grid item>
//               <Typography variant="h3">Entry Approvals ({total} total)</Typography>
//             </Grid>
//           </Grid>
//         }
//         content={false}
//       >
//         <Card>
//           <Paper sx={{ width: "100%", overflow: "hidden" }}>
//             <TableContainer sx={{ maxHeight: 600 }}>
//               <Table stickyHeader aria-label="approval table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>S. No.</TableCell>
//                     <TableCell>Approval ID</TableCell>
//                     <TableCell>Employee Name</TableCell>
//                     <TableCell>Employee ID</TableCell>
//                     <TableCell>Department</TableCell>
//                     <TableCell>Designation</TableCell>
//                     <TableCell>Email</TableCell>
//                     <TableCell>Entry Time</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {loading ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <Typography>Loading...</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : rows.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <Typography>No approvals found</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     rows.map((row, index) => (
//                       <TableRow hover key={row._id}>
//                         <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold" color="primary">
//                             {row.visitorId}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold">
//                             {row.fullName || "N/A"}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{row.employeeId || "N/A"}</TableCell>
//                         <TableCell>{row.department?.name || "N/A"}</TableCell>
//                         <TableCell>{row.designation || "N/A"}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2">{row.email}</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="caption" display="block">
//                             From: {formatDate(row.visitStart)}
//                           </Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             To: {formatDate(row.visitEnd)}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{getStatusChip(row.staff_status)}</TableCell>
//                         <TableCell align="center">
//                           <Stack direction="row" spacing={0.5} justifyContent="center">
//                             {row.status === PASS_STATUS.PENDING &&
//                             row.staff_status === PASS_STATUS.PENDING ? (
//                               <>
//                                 <Tooltip title="Accept">
//                                   <IconButton
//                                     size="small"
//                                     color="success"
//                                     onClick={() =>
//                                       updateStaffStatus(
//                                         row._id,
//                                         PASS_STATUS.ACCEPTED,
//                                         row.fullName || "Employee"
//                                       )
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     {updatingStatus[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <AcceptIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>

//                                 <Tooltip title="Reject">
//                                   <IconButton
//                                     size="small"
//                                     color="error"
//                                     onClick={() =>
//                                       updateStaffStatus(
//                                         row._id,
//                                         PASS_STATUS.REJECTED,
//                                         row.fullName || "Employee"
//                                       )
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     <RejectIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             ) : row.staff_status === PASS_STATUS.ACCEPTED ? (
//                               <Typography variant="body2" color="success.main">
//                                 ✅ Accepted by You
//                               </Typography>
//                             ) : row.staff_status === PASS_STATUS.REJECTED ? (
//                               <Typography variant="body2" color="error.main">
//                                 ❌ Rejected by You
//                               </Typography>
//                             ) : row.status !== PASS_STATUS.PENDING ? (
//                               <Typography variant="body2" color="warning.main">
//                                 ⚠️ Admin already{" "}
//                                 {row.status === PASS_STATUS.ACCEPTED ? "accepted" : "rejected"} this
//                                 request
//                               </Typography>
//                             ) : null}
//                           </Stack>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[5, 10, 25, 50]}
//               component="div"
//               count={total}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//             />
//           </Paper>
//         </Card>
//       </MainCard>
//     </>
//   );
// }


import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  TextField,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import {
  CheckCircle as AcceptIcon,
  Cancel as RejectIcon,
  Pending as PendingIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import MainCard from "ui-component/cards/MainCard";
import { gridSpacing } from "store/constant";
import { useDebounce } from "hooks/useDebounced";

const PASS_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accept",
  REJECTED: "reject",
};

export default function EntryApprovalStaff() {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState({});

  const debouncedSearch = useDebounce(search, 1000);

  // ✅ Fetch staff's submitted gate passes
  const fetchStaffGatePasses = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        search,
        status: statusFilter,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}staff/all-after-work-entry-exit-approval?${queryParams}`,
        {
          method: "GET",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (result.code === 200) {
        setRows(result.data.entryApprovals || []);
        setTotal(result.data.pagination?.total || 0);
      } else {
        toast.error(result.message || t("entryApproval.fetchError"));
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching approvals:", error);
      toast.error(t("entryApproval.fetchErrorGeneric"));
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaffGatePasses();
  }, [page, rowsPerPage, debouncedSearch, statusFilter]);

  // ✅ Pagination
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilter = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  // ✅ Update staff status
  const updateStaffStatus = async (id, newStatus, name) => {
    if (updatingStatus[id]) return;

    const actionText = newStatus === PASS_STATUS.ACCEPTED ? t("entryApproval.accept") : t("entryApproval.reject");

    swal({
      title: `${actionText} ${name}?`,
      text: t("entryApproval.confirmAction", { action: actionText.toLowerCase() }),
      icon: newStatus === PASS_STATUS.ACCEPTED ? "success" : "error",
      buttons: [t("entryApproval.cancel"), actionText],
      dangerMode: newStatus === PASS_STATUS.REJECTED,
    }).then(async (willProceed) => {
      if (!willProceed) return;

      try {
        setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}update-staff-entryapproval-status/${id}`,
          {
            method: "PUT",
            headers: {
              authkey: process.env.REACT_APP_AUTH_KEY,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ status: newStatus }),
          }
        );

        const result = await response.json();

        if (result.code === 200) {
          toast.success(t("entryApproval.actionSuccess", { action: actionText }));
          setRows((prev) =>
            prev.map((item) => (item._id === id ? { ...item, staff_status: newStatus } : item))
          );
        } else {
          toast.error(result.message || t("entryApproval.actionError", { action: actionText.toLowerCase() }));
        }
      } catch (error) {
        console.error("Error updating staff status:", error);
        toast.error(t("entryApproval.updateError"));
      } finally {
        setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
      }
    });
  };

  // ✅ Status chip UI
  const getStatusChip = (status) => {
    const statusConfig = {
      pending: { color: "warning", icon: <PendingIcon />, label: t("entryApproval.status.pending") },
      accept: { color: "success", icon: <AcceptIcon />, label: t("entryApproval.status.accepted") },
      reject: { color: "error", icon: <RejectIcon />, label: t("entryApproval.status.rejected") },
    };
    const config = statusConfig[status] || statusConfig.pending;

    return (
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size="small"
        variant="outlined"
      />
    );
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label={t("entryApproval.searchLabel")}
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t("entryApproval.searchPlaceholder")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>{t("entryApproval.statusFilter")}</InputLabel>
            <Select value={statusFilter} onChange={handleStatusFilter} label={t("entryApproval.statusFilter")}>
              <MenuItem value="all">{t("entryApproval.allStatus")}</MenuItem>
              <MenuItem value="pending">{t("entryApproval.status.pending")}</MenuItem>
              <MenuItem value="accept">{t("entryApproval.status.accepted")}</MenuItem>
              <MenuItem value="reject">{t("entryApproval.status.rejected")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <MainCard
        title={
          <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
            <Grid item>
              <Typography variant="h3">
                {t("entryApproval.title")} ({total} {t("entryApproval.total")})
              </Typography>
            </Grid>
          </Grid>
        }
        content={false}
      >
        <Card>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="approval table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("entryApproval.table.sno")}</TableCell>
                    <TableCell>{t("entryApproval.table.approvalId")}</TableCell>
                    <TableCell>{t("entryApproval.table.employeeName")}</TableCell>
                    <TableCell>{t("entryApproval.table.employeeId")}</TableCell>
                    <TableCell>{t("entryApproval.table.department")}</TableCell>
                    <TableCell>{t("entryApproval.table.designation")}</TableCell>
                    <TableCell>{t("entryApproval.table.email")}</TableCell>
                    <TableCell>{t("entryApproval.table.entryTime")}</TableCell>
                    <TableCell>{t("entryApproval.table.status")}</TableCell>
                    <TableCell align="center">{t("entryApproval.table.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("entryApproval.loading")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("entryApproval.noData")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, index) => (
                      <TableRow hover key={row._id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" color="primary">
                            {row.visitorId}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold">
                            {row.fullName || t("entryApproval.na")}
                          </Typography>
                        </TableCell>
                        <TableCell>{row.employeeId || t("entryApproval.na")}</TableCell>
                        <TableCell>{row.department?.name || t("entryApproval.na")}</TableCell>
                        <TableCell>{row.designation || t("entryApproval.na")}</TableCell>
                        <TableCell>
                          <Typography variant="body2">{row.email}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="caption" display="block">
                            {t("entryApproval.from")}: {formatDate(row.visitStart)}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {t("entryApproval.to")}: {formatDate(row.visitEnd)}
                          </Typography>
                        </TableCell>
                        <TableCell>{getStatusChip(row.staff_status)}</TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            {row.status === PASS_STATUS.PENDING &&
                            row.staff_status === PASS_STATUS.PENDING ? (
                              <>
                                <Tooltip title={t("entryApproval.accept")}>
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={() =>
                                      updateStaffStatus(
                                        row._id,
                                        PASS_STATUS.ACCEPTED,
                                        row.fullName || t("entryApproval.employee")
                                      )
                                    }
                                    disabled={!!updatingStatus[row._id]}
                                  >
                                    {updatingStatus[row._id] ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <AcceptIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title={t("entryApproval.reject")}>
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                      updateStaffStatus(
                                        row._id,
                                        PASS_STATUS.REJECTED,
                                        row.fullName || t("entryApproval.employee")
                                      )
                                    }
                                    disabled={!!updatingStatus[row._id]}
                                  >
                                    <RejectIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </>
                            ) : row.staff_status === PASS_STATUS.ACCEPTED ? (
                              <Typography variant="body2" color="success.main">
                                ✅ {t("entryApproval.acceptedByYou")}
                              </Typography>
                            ) : row.staff_status === PASS_STATUS.REJECTED ? (
                              <Typography variant="body2" color="error.main">
                                ❌ {t("entryApproval.rejectedByYou")}
                              </Typography>
                            ) : row.status !== PASS_STATUS.PENDING ? (
                              <Typography variant="body2" color="warning.main">
                                ⚠️ {t("entryApproval.adminAction", {
                                  action: row.status === PASS_STATUS.ACCEPTED ? t("entryApproval.accepted").toLowerCase() : t("entryApproval.rejected").toLowerCase()
                                })}
                              </Typography>
                            ) : null}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Card>
      </MainCard>
    </>
  );
}